<template>
  <div class="layout">
    <div class="content">
      <h1>Contact Us</h1>
      <p>
        To contact us for any questions you may have, please feel free to
        call<span>+64225198911</span> or send an email to:
        <span>info@starland.co.nz</span> Or use the form below to send us a
        message
      </p>
      <el-form
        :label-position="labelPosition"
        :model="formLabelAlign"
        :rules="rules"
        ref="contactForm"
      >
        <el-form-item prop="name">
          <el-input
            v-model="formLabelAlign.name"
            width="100"
            placeholder="Name"
          >
            <template #prefix>
              <img
                :src="require('../../assets/img/ContactUsIcon1.png')"
                style="width: 20px; height: 20px"
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="region">
          <el-input v-model="formLabelAlign.region" placeholder="Email">
            <template #prefix>
              <img
                :src="require('../../assets/img/ContactUsIcon2.png')"
                style="width: 20px; height: 20px"
              /> </template
          ></el-input>
        </el-form-item>
        <el-form-item prop="type">
          <el-input v-model="formLabelAlign.type" placeholder="Your Message">
            <template #prefix>
              <img
                :src="require('../../assets/img/ContactUsIcon3.png')"
                style="width: 20px; height: 20px"
              /> </template
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="submitForm">Send</el-button>
    </div>
  </div>
</template>
<script>
import { urlRequest } from "../../common/common";

export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please enter your name",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter a valid email",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "Please enter your message",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          // 校验通过后的逻辑
          urlRequest({
            url: this.api.contactUs,
            method: "post",
            data: {
              name: this.formLabelAlign.name,
              email: this.formLabelAlign.region,
              message: this.formLabelAlign.type,
            },
            isShowMask: false,
          }).then((res) => {
            if (res.data.code === 200) {
              alert("Form submitted successfully!");
            } else {
              alert("Form submitted failed!");
            }
          });
        } else {
          // 校验未通过的逻辑
          console.log("Validation failed!");
        }
      });
    },
  },
  mounted() {
    const img = new Image();
    img.src = require("../../assets/img/contactUs.png");
    img.onload = () => {
      console.log("Background image preloaded");
      document.querySelector(
        ".layout"
      ).style.backgroundImage = `url(${img.src})`;
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "contactUs.scss";
</style>
